import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../AccessControl/AccessControlTypes';
import { Data } from '@singularsystems/neo-core';
import ProvisionalTaxReportsSearchCriteria from '../Models/Queries/ProvisionalTaxReportsSearchCriteria';
import UnrealisedGainsSummaryLookup from '../Models/Lookups/UnrealisedGainsSummaryLookup';

export default class UnrealisedGainsSummaryVM extends Views.ViewModelBase {
  public provisionalTaxReportsSearchCriteria: ProvisionalTaxReportsSearchCriteria = new ProvisionalTaxReportsSearchCriteria();
  public unrealisedGainsSummaryPageManager = new Data.PageManager(this.provisionalTaxReportsSearchCriteria, UnrealisedGainsSummaryLookup,
     this.provisionalTaxReportsApiClient.getUnrealisedGainsSummaryPagedList, {
        pageSize: 10, 
        sortAscending: true,
        fetchInitial: false,
        sortBy: "clientAccountID",
        initialTaskRunner: this.taskRunner,
     }
   );

   constructor(
      taskRunner = AppService.get(Types.Neo.TaskRunner),
      private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
      private provisionalTaxReportsApiClient = AppService.get(Types.ApiClients.ProvisionalTaxReportsApiClient)) {
      super(taskRunner);
    }   

    public async initialise() {
    }

    public async search(searchCriteria: ProvisionalTaxReportsSearchCriteria) {
      this.provisionalTaxReportsSearchCriteria.mapFrom(searchCriteria);      
    }
}